module.exports = __webpack_public_path__ + "img_Kaitak_pattern.0ed1e59e8499923dc69a.png";